import { render, staticRenderFns } from "./AmbulanciasBtn.vue?vue&type=template&id=afb90800"
import script from "./AmbulanciasBtn.vue?vue&type=script&lang=js"
export * from "./AmbulanciasBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports